export const inputBase = {
  backgroundColor: '#0f1117',
  border: '1px solid #1e2130',
  color: '#e4e6f0',
  borderRadius: '8px',
  fontSize: '13px',
  padding: '8px 12px',
  outline: 'none',
  width: '100%',
  transition: 'border-color 0.15s, box-shadow 0.15s',
};

export const inputFocused = {
  borderColor: 'rgba(59,130,246,0.5)',
  boxShadow: '0 0 0 3px rgba(59,130,246,0.08)',
};
